import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeleteIncentiveFromTheOrderRequestBody as SchemaDeleteIncentiveFromTheOrderRequestBody } from '../schemas/DeleteIncentiveFromTheOrderRequestBody';
import { type DeleteIncentiveFromTheOrderResult as SchemaDeleteIncentiveFromTheOrderResult } from '../schemas/DeleteIncentiveFromTheOrderResult';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const DeleteIncentiveFromTheOrderContentType = 'application/json' as const;
export type DeleteIncentiveFromTheOrderRequest = SchemaDeleteIncentiveFromTheOrderRequestBody;
export type DeleteIncentiveFromTheOrderResponses = LinkCommonErrorResponses & {
    /**
     * @description Incentive deleted
     */
    '200': {
        'application/json': SchemaDeleteIncentiveFromTheOrderResult;
    };
};
export type DeleteIncentiveFromTheOrderResponseSuccess =
    DeleteIncentiveFromTheOrderResponses['200']['application/json'];
export type DeleteIncentiveFromTheOrderSearchParams = {
    signature: string;
};
export type DeleteIncentiveFromTheOrderPathParameters = {
    store_slug: string;
    order_id: string;
};
export const DeleteIncentiveFromTheOrderUrl = '/{store_slug}/orders/{order_id}/incentive' as const;
export const DeleteIncentiveFromTheOrderMethod = 'DELETE' as const;
export const getDeleteIncentiveFromTheOrderUrl = (params: DeleteIncentiveFromTheOrderPathParameters) =>
    DeleteIncentiveFromTheOrderUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof DeleteIncentiveFromTheOrderPathParameters) => String(params[param])
    );
